import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import { abbreviateNumericValue } from '@openx/utils/lib/abbreviateNumericValue.ts';
import { useTranslation } from 'react-i18next';
import { spendTooltip } from '../../constants.ts';
import { LeadingStatsGridItem } from './stats/LeadingStatsGridItem.tsx';
import { StatsItem } from './stats/StatsItem.tsx';

export type DealPromptTileStatsProps = {
  potentialSpend?: number;
  marketRequests?: number;
  relevance?: number;
  averageCpm?: number;
  impressions?: number;
  viewability?: number;
  activeIPs?: number;
  avgCPM?: number;
  reach?: number;
};

export const DealPromptTileStats = ({
  potentialSpend,
  marketRequests,
  relevance,
  averageCpm,
  impressions,
  viewability,
}: DealPromptTileStatsProps) => {
  const { t } = useTranslation();

  const potentialSpendValue = `$${abbreviateNumericValue(potentialSpend, { decimalPlaces: 2 })}`;
  const marketRequestsValue = abbreviateNumericValue(marketRequests, { decimalPlaces: 2 });
  const relevanceValue = `${abbreviateNumericValue(relevance, { decimalPlaces: 0 })}%`;
  const averageCpmValue = `$${abbreviateNumericValue(averageCpm, { decimalPlaces: 2 })}`;
  const impressionsValue = abbreviateNumericValue(impressions, { decimalPlaces: 2 });
  const viewabilityValue = `${abbreviateNumericValue(viewability, { decimalPlaces: 0 })}%`;

  return (
    <Stack spacing={1.5} sx={{ pt: 2, pb: 1, width: '100%', alignItems: 'center' }}>
      <Grid container size={12} sx={{ px: 1, width: '100%' }}>
        <LeadingStatsGridItem
          label={t('30d Spend')}
          tooltip={t(spendTooltip)}
          value={potentialSpendValue}
          dataTest="potential-spend"
        />

        <LeadingStatsGridItem label={t('Market Requests')} value={marketRequestsValue} dataTest="market-requests" />

        <LeadingStatsGridItem
          label={t('Relevance')}
          value={relevanceValue}
          valueColor="success.main"
          dataTest="relevance"
        />
      </Grid>

      <Divider sx={{ width: '92%' }} data-test="divider" />

      <Stack sx={{ width: '100%', px: 2 }}>
        <StatsItem label={t('Avg CPM')} value={averageCpmValue} dataTest="avg-cpm" />

        <StatsItem label={t('Impressions')} value={impressionsValue} dataTest="impressions" />

        <StatsItem label={t('Viewability')} value={viewabilityValue} dataTest="viewability" />
      </Stack>
    </Stack>
  );
};
